<!-- 修改 -->
<template>
  <div class="essay-info-fill">
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="essay-info-fill-item">
        <h1>文书</h1>
        <FormItem label="文书名称"
                  prop="title">
          <Input v-model.trim="formValidate.title"
                 placeholder="Please limit tittle to 30 words"></Input>
        </FormItem>
        <FormItem label="字数限制"
                  prop="count">
          <Input v-model.trim="formValidate.count"></Input>
        </FormItem>
        <FormItem label="文书描述 (Please limit your response to 200 words)"
                  prop="description">
          <div class="essay-editor">
            <editor ref="analysisEditor"
                    :cache=false
                    v-model="formValidate.description" />
          </div>
        </FormItem>
      </div>
    </Form>
    <div class="essay-info-btn">
      <Button class="btn"
              @click="subHandle"
              :loading="isSub">确认信息</Button>
    </div>
    <zlr-modal v-model="isShow">
      <div class="essay-info-fill-modal">
        <h1>是否已经填写该项目下所有文书？</h1>
        <p>如果您选择给出了该项目下所有的文书，将不能填写更多的文书信息；如果您选择了未给出该项目下所有的文书，导师将会根据已经填写的文书，合理安排时间进行修改；</p>
        <div>
          <Button @click="sendData(true)"
                  :disabled="isSub">是</Button>
          <Button @click="sendData(false)"
                  :disabled="isSub">否</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { getBillDetail, subBillModify } from '@/api/bill'
// components
import Editor from '_c/editor/editor'
import ZlrModal from '_c/modal/modal'
// validator
import { validateChinese, validateWordsNum, validateNumber } from '@/libs/validator'
export default {
  name: 'project-essay-info-edit',
  components: {
    Editor,
    ZlrModal
  },
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        title: [
          {
            required: true,
            message: '请填写文书名称'
          },
          {
            validator: validateChinese
          },
          {
            validator: validateWordsNum,
            wordsNum: 30
          }
        ],
        count: [
          {
            required: true,
            message: '请填写字数限制'
          },
          // {
          //   validator: validateNumber
          // }
        ],
        description: [
          {
            required: true,
            message: '请填写文书描述'
          }
        ]
      },
      isShow: false,
      isSub: false,
      id: this.$route.query.id
    }
  },
  computed: {},
  mounted () {
    this.getBillDetail()
  },
  methods: {
    // 获取详情
    getBillDetail () {
      getBillDetail({
        id: this.id
      }).then(res => {
        let data = res.data.model
        this.formValidate = {
          description: data.description,
          title: data.title,
          count: data.count
        }
      })
    },
    // 提交信息
    subHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.isShow = true
        }
      })
    },
    sendData (isFill) {
      let data = Object.assign({}, this.formValidate)
      data.programId = this.$route.params.id
      data.hasFinish = isFill
      data.id = this.id
      this.isShow = false
      this.isSub = true
      subBillModify(data).then(res => {
        this.$zlr_message('添加成功', 'success')
        this.$router.push({
          name: 'project-essay-info-detail'
        })
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
